module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/view-container/view-container.component.css
// module id = ./src/app/components/view-container/view-container.component.css
// module chunks = main